var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLightIcon = function SvgLightIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 50 59",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "079---Brightness",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23 0h4c1.1045695 0 2 .8954305 2 2v3h-8v-3c0-1.1045695.8954305-2 2-2z",
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m43 34c0 9.9411255-8.0588745 18-18 18s-18-8.0588745-18-18c-.02385451-1.7484817.21205132-3.4908147.7-5.17 2.54-8.69 11.3-9.84 11.3-16.83l6-2 6 2c0 6.99 8.76 8.14 11.3 16.83.4879487 1.6791853.7238545 3.4215183.7 5.17z",
    fill: "#f3d55b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42.3 28.83c-3.0704159 6.7996209-9.839283 11.1700653-17.3 11.1700653s-14.2295841-4.3704444-17.3-11.1700653c2.54-8.69 11.3-9.84 11.3-16.83l6-2 6 2c0 6.99 8.76 8.14 11.3 16.83z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23 24c-.5522847 0-1-.4477153-1-1v-11c0-.5522847.4477153-1 1-1s1 .4477153 1 1v11c0 .5522847-.4477153 1-1 1z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23 29c-.5522847 0-1-.4477153-1-1v-1c0-.5522847.4477153-1 1-1s1 .4477153 1 1v1c0 .5522847-.4477153 1-1 1z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 24c-.5522847 0-1-.4477153-1-1v-11c0-.5522847.4477153-1 1-1s1 .4477153 1 1v11c0 .5522847-.4477153 1-1 1z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 29c-.5522847 0-1-.4477153-1-1v-1c0-.5522847.4477153-1 1-1s1 .4477153 1 1v1c0 .5522847-.4477153 1-1 1z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m31 6v6h-12v-6c.0032948-1.10320187.8967981-1.9967052 2-2h8c1.1032019.0032948 1.9967052.89679813 2 2z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m31 7v2h-8c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1z",
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f29c1f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m25 59c-.5522847 0-1-.4477153-1-1v-2c0-.5522847.4477153-1 1-1s1 .4477153 1 1v2c0 .5522847-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m37 55.784c-.3576137.0003484-.6881932-.1902972-.867-.5l-1-1.731c-.1814844-.3095704-.1831833-.6926495-.0044519-1.0038174.1787315-.311168.5104885-.5027136.8693336-.5019247s.6897567.1937913.8671183.5057421l1 1.731c.1785415.3092425.1786393.6902222.0002566.9995563s-.5081742.5000777-.8652566.5004437z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m45.783 47c-.1755887.0003718-.3481299-.0458692-.5-.134l-1.731-1c-.3119508-.1773616-.5049532-.5082732-.5057421-.8671183s.1907567-.6906021.5019247-.8693336c.3111679-.1787314.694247-.1770325 1.0038174.0044519l1.731 1c.3919413.2263139.5830208.6876562.4658809 1.1248223-.1171398.4371661-.5132928.7411578-.9658809.7411777z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m49 35h-2c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h2c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m44.054 24c-.4525881-.0000199-.8487411-.3040116-.9658809-.7411777-.1171399-.4371661.0739396-.8985084.4658809-1.1248223l1.731-1c.47786-.2716903 1.0854205-.1067416 1.3602745.3693057.2748541.4760473.1139391 1.0846885-.3602745 1.3626943l-1.731 1c-.1518701.0881308-.3244113.1343718-.5.134z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m5.946 24c-.17558875.0003718-.34812995-.0458692-.5-.134l-1.731-1c-.47421361-.2780058-.63512861-.886647-.36027453-1.3626943s.88241457-.640996 1.36027453-.3693057l1.731 1c.39194126.2263139.58302085.6876562.46588095 1.1248223s-.51329289.7411578-.96588095.7411777z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m3 35h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m4.217 47c-.45258806-.0000199-.84874105-.3040116-.96588095-.7411777s.07393969-.8985084.46588095-1.1248223l1.731-1c.30957042-.1814844.69264947-.1831833 1.00381742-.0044519.31116795.1787315.50271357.5104885.50192468.8693336-.00078888.3588451-.19379132.6897567-.5057421.8671183l-1.731 1c-.15187005.0881308-.32441125.1343718-.5.134z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m13 55.784c-.3570824-.000366-.6868739-.1911096-.8652566-.5004437s-.1782849-.6903138.0002566-.9995563l1-1.731c.2780058-.4742136.886647-.6351286 1.3626943-.3602745.4760473.274854.640996.8824145.3693057 1.3602745l-1 1.731c-.1788068.3097028-.5093863.5003484-.867.5z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lightIcon.560c7e56.svg";
export { ForwardRef as ReactComponent };